import React, {useEffect, useState} from 'react';
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaPlus} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import {useParams} from "react-router";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import InputForm from "../../../../components/input/input-form.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputTextarea from "../../../../components/input/input-textarea.jsx";
import {useQuery} from "@tanstack/react-query";
import natureService from "../../../../services/web/nature-service.js";
import NatureImage from "./components/nature-image.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import Swal from "sweetalert2";
import bosService from "../../../../services/web/bos-service.js";

const initialState = {
    name: "",
    alias: "",
    dispatch: false,
    sentry: false,
    janitorial: false,
    group_reason: "",
    dispatch_numbercheckbook: false,
    dispatch_activity: false,
    dispatch_occurrence: "",
    attendance_procedure: "",
    law: "",
    classification: [],
    pending_process: false,
    show_in_quick_register: false,
    interligation: false,
}

const classificationList = [
    {value: "infraction", label: "Ato infracional"},
    {value: "inquirity_complain", label: "Averiguação"},
    {value: "consummate", label: "Consumado"},
    {value: "denunciation", label: "Denúncia"},
    {value: "tempted", label: "Tentado"},
]
const NatureForm = () => {
    const navigate = navigateHook();

    const {id} = useParams()
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState(initialState)

    const { refetch: refetchNature, fetchStatus} = useQuery({
        queryFn: () =>  natureService.get(id).then((data) => {
            const keysToCheck = ['tempted', 'consummate', 'infraction', 'inquirity_complain', 'denunciation'];

            data.classification = keysToCheck.filter(key => data[key] === true);
            if (!data?.marker) data.marker = "default.svg"
            setState(prev => ({ ...prev, ...data }));
            return []
        }),
        queryKey: ['nature'],
        enabled: !!id
    });

    const { data: boName} = useQuery({
        queryFn: () =>  bosService.getBoName().then((data) => {
            return data
        }),
        queryKey: ['boName']
    });

    useEffect(() => {
        if (id) {
            if (fetchStatus === 'idle') setIsLoading(false)
            else setIsLoading(true)
        }
    }, [fetchStatus]);

    const dispatchOccurrenceList = [
        {value: "FORBIDDEN", label: `Não permitir gerar número de ${boName}`},
        {value: "ALLOWED", label: `Permitir gerar número de ${boName}`},
        {value: "MANDATORY", label: `Obrigar gerar número de ${boName}`},
    ]

    const { data: groupsList} = useQuery({
        queryFn: () =>  natureService.groups().then((data) => {
            const newData = []
            data.map(d => newData.push({ value: d.id, label: d.text }));

            return newData
        }),
        queryKey: ['groups']
    });

    const { data: interligationList} = useQuery({
        queryFn: () =>  natureService.getInterligation().then((data) => {
            const newData = []
            data.map(d => newData.push({ value: d.id, label: d.text }));

            return newData
        }),
        queryKey: ['interligation']
    });

    const onChange = ({target: {value, id}}) => setState(prev => ({...prev, [id]: value}))

    const handleInputs = (id, value) => setState(prev => ({...prev, [id]: value}));

    const onChangeMultiSelect = (value) => setState(prev => ({...prev, classification: value.map(item => item.value)}))

    const handleKeyDown = ({key}) => {
        if (key === 'Enter')  save();
    }

    const save = () => {
        const formData = new FormData();

        Object.keys(state)
            .filter(key => !["attach", "classification"].includes(key))
            .forEach(key => {
                let data = state[key];
                if (typeof data === 'object') data = data?.value ?? "";

                formData.append(key, data);
            });


        if (!!id) formData.append('_method', 'PUT');

        if(state.attach) formData.append("image-file", state.attach);

        if (state?.classification.length > 0) {
            state.classification.forEach(item => {
                formData.append("classification[]", item);
            });
        }

        const response = !!id ? natureService.edit(id, formData) : natureService.create(formData);
        response
            .then(({data}) => {
                projectUtils.success(!id);

                if (id) {
                    refetchNature();
                    return;
                }

                navigateToEdit(data)
            })
            .catch((error) => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = message ?? "Não foi possível salvar.";
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            })
    }

    const destroy = () => {
        Swal.fire({
            title: "Excluir",
            text: `Excluir a natureza "${state.name ? state.name : state.alias}"?`,
            icon: "warning",
            confirmButtonText: "Sim",
            confirmButtonColor: "#063A6C",
            cancelButtonText: "Não",
            cancelButtonColor: "#c10007",
            showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            reverseButtons: true
        }).then(({isConfirmed}) => {
            if (isConfirmed) {
                natureService.destroy(id).then(() => {
                    navigateToList()
                    projectUtils.success(true, "Excluído com sucesso");
                })
            }
        });
    }
    const newNature = (isBlank = false) => {
        let urlDev = `/nature/form`;
        navigate(urlDev, isBlank);
    }

    const navigateToEdit = (data) => {
        let isBlank = false;
        let urlDev = `/nature/form/${data.id}`;
        navigate(urlDev, isBlank);
    }

    const navigateToList = () => {
        let isBlank = false;
        let urlDev = `/nature`;
        navigate(urlDev, isBlank);
    }

    useEffect(() => {
        if(state.dispatch_activity){
            handleInputs("dispatch_occurrence", "FORBIDDEN")
        }
    }, [state.dispatch_activity]);

    useEffect(() => {
        if (!state.dispatch){
            setState(prev => ({ ...prev, dispatch_numbercheckbook: false, dispatch_activity: false, dispatch_occurrence: "", attendance_procedure: "" }))
        }

        if(!state.sentry){
            setState(prev => ({ ...prev, pending_process: false, show_in_quick_register: false, law: "", classification: [], interligation: false, auto_share: "" }))
        }

        if(!state.interligation){
            setState(prev => ({ ...prev, auto_share: "" }))
        }

    }, [state.dispatch, state.sentry, state.interligation]);

    const handleClick = (e) => {
        if (e.ctrlKey) {
            newNature(true)
            return;
        }

        newNature()
    }

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>
                    Natureza de ocorrência
                </Template.Title>
                {
                    id &&
                    <>
                        <Button target={"primary-outline"} onClick={(e) => handleClick(e)}>
                            <FaPlus/>
                            Adicionar natureza
                        </Button>
                    </>
                }
            </Template.Header>

            <Template.Body>
                <Card>
                    <Card.Body>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-2">
                                <NatureImage setState={setState} state={state} />
                            </div>

                            <div className="col-span-10 relative">
                                <div className={"grid grid-cols-12 gap-x-4 mb-3"}>
                                        <div className="col-span-6">
                                            <InputForm id="name" value={state.name} disabled={true}
                                                       label="Nome de sistema *"/>
                                        </div>
                                        <div className="col-span-6">
                                            <InputForm id="alias" value={state.alias} onChange={onChange} onKeyDown={handleKeyDown}
                                                       label="Nome apresentável *"/>
                                        </div>

                                    <p className="col-span-12 mt-7">Módulos:</p>
                                    <div className="col-span-6 relative">
                                        <div className={"grid grid-cols-12 mb-3"}>
                                            <div className="col-span-3 mr-2">
                                                <InputCheckbox id="dispatch" checked={state.dispatch}
                                                               label="Despacho"
                                                               onChange={({target: {checked}}) => handleInputs("dispatch", checked)}
                                                />
                                            </div>
                                            <div className="col-span-3 mr-5">
                                                <InputCheckbox id="sentry" checked={state.sentry}
                                                               label="Sentry"
                                                               onChange={({target: {checked}}) => handleInputs("sentry", checked)}
                                                />
                                            </div>
                                            <div className="col-span-6">
                                                <InputCheckbox id="janitorial" checked={state.janitorial}
                                                               label="Zeladoria"
                                                               onChange={({target: {checked}}) => handleInputs("janitorial", checked)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-span-6 -mt-[15px]">
                                        <SelectComponent
                                            name="group_reason"
                                            value={state.group_reason}
                                            options={groupsList}
                                            label={"Grupo de naturezas"}
                                            onChange={(selected) => handleInputs("group_reason", selected?.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card className={"mt-2 " + (state.dispatch ? "block" : "hidden")}>
                    <Card.Header className={"gap-2"}>
                        <Card.Title>Despacho</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <div className="grid grid-cols-12 gap-4">

                            <div className="col-span-12">
                                <InputCheckbox id="dispatch_numbercheckbook" checked={state.dispatch_numbercheckbook}
                                               label="Gerar número de talão para os despachos"
                                               onChange={({target: {checked}}) => handleInputs("dispatch_numbercheckbook", checked)}
                                />
                            </div>

                            <div className="col-span-12">
                                <InputCheckbox id="dispatch_activity" checked={state.dispatch_activity}
                                               label="Definir como registro de atividades"
                                               onChange={({target: {checked}}) => handleInputs("dispatch_activity", checked)}
                                />
                            </div>

                            <div className="col-span-6">
                                <SelectComponent
                                    name="dispatch_occurrence"
                                    value={state.dispatch_occurrence}
                                    options={dispatchOccurrenceList}
                                    label={`Opções da numeração de ${boName}`}
                                    onChange={(selected) => handleInputs("dispatch_occurrence", selected?.value)}
                                    isDisabled={state.dispatch_activity}
                                />
                            </div>

                            <div className="col-span-12">
                                <InputTextarea
                                    id={"attendance_procedure"}
                                    className={"col-span-full"}
                                    textAreaClass={"h-30"}
                                    label={"Modelo para preenchimento do atendimento"}
                                    value={state.attendance_procedure}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card className={"mt-2 " + (state.sentry ? "block" : "hidden")}>
                    <Card.Header className={"gap-2"}>
                        <Card.Title>Sentry</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <div className={"grid grid-cols-12 gap-4 mb-3"}>

                            <div className="col-span-3">
                                <InputForm id="law" value={state.law} onChange={onChange} onKeyDown={handleKeyDown}
                                           label="Artigos"/>
                            </div>
                            <div className="col-span-6">
                                <SelectComponent
                                    name="classification"
                                    value={state.classification ? state.classification.map(item => {
                                        return classificationList.find(classific => classific.value === item)
                                    }) : []}
                                    options={classificationList ?? []}
                                    label={"Classificação"}
                                    onChange={onChangeMultiSelect}
                                    isMulti
                                />
                            </div>

                            <div className="col-span-12">
                                <InputCheckbox id="pending_process" checked={state.pending_process}
                                               label="Destacar quando não houver boletim de ocorrência"
                                               onChange={({target: {checked}}) => handleInputs("pending_process", checked)}
                                />
                            </div>

                            <div className="col-span-12">
                                <InputCheckbox id="show_in_quick_register" checked={state.show_in_quick_register}
                                               label="Cadastro rápido"
                                               onChange={({target: {checked}}) => handleInputs("show_in_quick_register", checked)}
                                />
                            </div>

                            {
                                state.name &&
                                <>
                                    <div className={"col-span-12"}>
                                        <Card>
                                            <Card.Header className={"gap-2"}>
                                                <Card.Title>Compartilhamento</Card.Title>
                                            </Card.Header>
                                            <Card.Body>
                                                <div className={"grid grid-cols-12 gap-4 mb-3"}>
                                                    <div className="col-span-12">
                                                        <InputCheckbox id="interligation" checked={state.interligation}
                                                                       label="Permitir compartilhar as ocorrências dessa natureza com outras corporações (SentryCloud)"
                                                                       onChange={({target: {checked}}) => handleInputs("interligation", checked)}
                                                        />
                                                    </div>
                                                    <div className="col-span-12">
                                                        <SelectComponent
                                                            name="auto_share"
                                                            value={state.auto_share}
                                                            options={interligationList}
                                                            label={"Ativar o compartilhamento automaticamente ao criar uma ocorrência"}
                                                            onChange={(selected) => handleInputs("auto_share", selected?.value)}
                                                            isDisabled={!state.interligation}
                                                        />
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                </>
                            }
                        </div>
                    </Card.Body>
                </Card>

                <Card className={"mt-2"}>
                    <Card.Body>
                        <div className="w-full flex justify-end">
                            <div className="flex gap-2">
                                {
                                    (id && !state.name) &&
                                    <>
                                        <Button target="danger" onClick={destroy} actionFeedbackType='delete'>

                                            Excluir
                                        </Button>
                                    </>
                                }

                                <Button onClick={save} actionFeedbackType='save'>

                                    Salvar
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>

        </Template>
    );
};

export default NatureForm;